import gql from 'graphql-tag';

export const featuresQuery = gql`
  query Features {
    features {
      id
      createdAt
      title
      description
      entity {
        id
        name
      }
      user {
        id
        firstName
        lastName
      }
      votes {
        user {
          id
          firstName
          lastName
        }
        entity {
          id
          name
        }
      }
    }
  }
`;
